import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'monthyear' })
export class MonthYearPipe implements PipeTransform {
	transform(value: Date): string {
		if (!value)
			return null;
		return moment(value).format("MMM-YYYY");
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/month-year.pipe.ts